import type { GetRoadmapDetail200CoursesItemInstructorBasicInfo } from './getRoadmapDetail200CoursesItemInstructorBasicInfo';
import type { GetRoadmapDetail200CoursesItemInstructorSocial } from './getRoadmapDetail200CoursesItemInstructorSocial';

/**
 * 강사 정보
 */
export type GetRoadmapDetail200CoursesItemInstructor = {
  /** 사용자 기본 정보 */
  basicInfo: GetRoadmapDetail200CoursesItemInstructorBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetRoadmapDetail200CoursesItemInstructorSocial;
};
